export default __webpack_public_path__ + "static/media/350px-Headshot.f6de0f5b.jpg";